/**
 * Navigation Mobile
 */

document.addEventListener('DOMContentLoaded', () => {
  const navigationMobile = document.querySelector('.navigation-mobile');

  // Check whether the navigationMobile element exists
  if (!navigationMobile) {
    return;
  }

  // Event delegation for submenu toggles and dismiss buttons
  navigationMobile.addEventListener('click', (event) => {
    const target = event.target;

    // Toggle submenu
    if (target.classList.contains('submenu-toggle')) {
      const submenu = target.nextElementSibling;
      // Set the class to show
      submenu.classList.toggle('show');
      submenu.setAttribute('aria-hidden', false);
    }

    // Dismiss submenu
    const submenuDismiss = target.closest('[data-bs-dismiss="navigation-mobile-submenu"]');
    if (submenuDismiss) {
      console.log("test");
      const submenu = submenuDismiss.closest('.submenu');
      submenu.classList.remove('show');
      submenu.setAttribute('aria-hidden', true);
    }

    // Toggle dropdown
    if (target.classList.contains('dropdown-header')) {
      const dropdown = target.nextElementSibling;
      dropdown.classList.toggle('show');
    }

    // Dismiss dropdown
    if (target.getAttribute('data-bs-dismiss') === 'navigation-mobile-dropdown') {
      const dropdown = target.closest('.submenu-inner');
      dropdown.classList.remove('show');
    }
  });

  // When the .navigation-mobile offcanvas is hidden, remove the .show class from the .submenu and .submenu-inner elements
  navigationMobile.addEventListener('hidden.bs.offcanvas', () => {
    const submenus = navigationMobile.querySelectorAll('.submenu');
    submenus.forEach((submenu) => {
      submenu.classList.remove('show');
      submenu.setAttribute('aria-hidden', true);
    });

    const dropdowns = navigationMobile.querySelectorAll('.submenu-inner');
    dropdowns.forEach((dropdown) => {
      dropdown.classList.remove('show');
    });
  });
});
